import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'priceFormat',
    standalone: true
})
export class PriceFormatPipe implements PipeTransform {
    transform(value: any, decimal: number = 2): string {
        if (value === null || value === undefined || value === '') {
            return '';
        }

        const num = parseFloat(value);
        if (isNaN(num)) {
            return value;
        }

        return num
            .toLocaleString('en-US', {
                minimumFractionDigits: decimal,
                maximumFractionDigits: decimal
            });
    }
}
